import { GoogleAnalyticsService } from 'ngx-google-analytics';

export abstract class BaseGoogleAnalyticsCategory {
  constructor(private ga: GoogleAnalyticsService, protected name: string, private isEnabled: boolean) {}

  protected event(action: string, label?: string, value?: number) {
    if (!this.isEnabled) return;

    this.ga.event(action, this.name, label, value);
  }
}
